import { ElementProvider } from './ElementProvider';
import { NewCardPaymentElementData, useNewCardPaymentElement } from './useNewCardPaymentElement';

export interface IWithNewCardPaymentElementProps {
  newCardPaymentElementData: NewCardPaymentElementData;
}

export function withNewCardPaymentElement<P extends { stripePublicKey: string }>(
  WrappedComponent: React.ComponentType<
    React.PropsWithChildren<P & IWithNewCardPaymentElementProps>
  >
) {
  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const WithNewCardPaymentElementComponent = withNewCardPaymentElementData(WrappedComponent);

  const WithElementProviderComponent: React.FC<P> = (props: P) => {
    return (
      <ElementProvider stripePublicKey={props.stripePublicKey}>
        <WithNewCardPaymentElementComponent {...props} key={1} />
      </ElementProvider>
    );
  };
  WithElementProviderComponent.displayName = `WithElementProvider(${wrappedComponentName})`;
  return WithElementProviderComponent;
}

export function withNewCardPaymentElementData<P>(
  WrappedComponent: React.ComponentType<
    React.PropsWithChildren<P & IWithNewCardPaymentElementProps>
  >
) {
  const WithNewCardPaymentElementComponent: React.FC<P> = (props: P) => {
    const newCardPaymentElementData = useNewCardPaymentElement();
    return <WrappedComponent {...props} newCardPaymentElementData={newCardPaymentElementData} />;
  };
  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithNewCardPaymentElementComponent.displayName = `withNewCardPaymentElementData(${wrappedComponentName})`;
  return WithNewCardPaymentElementComponent;
}
